import { useState, useEffect } from 'react';


interface UseIsVisibleOptions {
  root?: Element | null;       // scrollable container
  threshold?: number | number[];
}

export function useIsVisible(
  element: HTMLElement | null,
  options: UseIsVisibleOptions = {}
) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      {
        root: options.root ?? null,     // null = viewport
        threshold: options.threshold ?? 0.01,
      }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [element, options.root, options.threshold]);

  return isVisible;
}